"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _excluded = ["forwardedRef", "disabled", "style", "disabledStyle", "focusedStyle"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInput(props) {
  var forwardedRef = props.forwardedRef,
    disabled = props.disabled,
    style = props.style,
    disabledStyle = props.disabledStyle,
    focusedStyle = props.focusedStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var currentRef = (0, _react.useRef)();
  var inputRef = forwardedRef || currentRef;
  var focused = inputRef && inputRef.current && inputRef.current.isFocused && inputRef.current.isFocused();
  var inputStyles = [styles["default"], style, disabled && styles.disabled, disabled && disabledStyle, focused && styles.focused, focused && focusedStyle];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TextInput, (0, _extends2["default"])({
    ref: inputRef,
    editable: !disabled,
    selectionColor: _styles.colors.feature,
    placeholderTextColor: _styles.colors.subtle,
    style: inputStyles
  }, rest));
}
TextInput.defaultProps = TextInput.defaultProps || {};
TextInput.defaultProps.allowFontScaling = false;
// Forwards the component reference
// https://reactjs.org/docs/forwarding-refs.html
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(TextInput, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});
var styles = _reactNative.StyleSheet.create({
  "default": _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _styles.typography.defaultTextStyle), _styles.sizes.selectStyleByDefaultSize({
    small: {
      fontSize: 14,
      paddingTop: 4,
      paddingBottom: 4,
      paddingRight: 12,
      paddingLeft: 12
    },
    medium: {
      fontSize: 15,
      paddingTop: 8,
      paddingBottom: 8,
      paddingRight: 12,
      paddingLeft: 12
    },
    large: {
      fontSize: 18,
      padding: 12
    }
  })), _reactNative.Platform.select({
    web: {
      lineHeight: 24
    }
  })), {}, {
    color: _styles.colors.feature,
    borderWidth: 1,
    borderColor: _styles.colors.common,
    borderRadius: 4
  }),
  focused: {
    color: _styles.colors.feature,
    borderColor: _styles.colors.feature
  },
  disabled: {
    color: _styles.colors.common,
    borderColor: _styles.colors.subtle,
    backgroundColor: _styles.backgroundColors.subtle
  }
});
TextInput.propTypes = {
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onChangeText: _propTypes["default"].func,
  style: _propTypes["default"].any,
  disabledStyle: _propTypes["default"].any
};